<h4 mat-dialog-title>{{description}}</h4>
<div mat-dialog-content>
      <ul style="padding: 0;margin-bottom: 0; font-size: 13px">
        <li style="list-style: none">
           <div class="txn-result-item">
               <div id ="identy_transaction_state_o">
                   <div id="trans_image" *ngIf="showIcon === 'success'" style="text-align: center">
                     <img *ngIf="aligned" src="{{aligned}}" width="80%" alt="">
                   </div>
                   <div id="trans_image" *ngIf="showIcon !== 'success'" class="{{showIcon}}" style="height: 150px"></div>
               </div>
           </div>
        </li>
        <li style="display: block; padding: 0" *ngIf="eyeStatus">
          <mat-tab-group>
            <mat-tab label="General">
              <table>
                <tr>
                  <td>Eyes: {{eyeStatus + ' ' + eyeOpenness}}</td>
                </tr>
                <tr>
                  <td>Face Quality: {{blur}}</td>
                </tr>
              </table>
            </mat-tab>
            <mat-tab label="ICAO" *ngIf="icao">
              <table>
                <tr>
                  <td>{{icao | json}}</td>
                </tr>
              </table>
            </mat-tab>
          </mat-tab-group>
        </li>
      </ul>
</div>
<div mat-dialog-actions align="center">
  <button mat-button *ngIf="!showRetry" (click)="onCloseClicked()" style="background: #00409E;color: white" id="closebtn"> {{closeButtonlabel}}</button>
  <button mat-button *ngIf="showRetry"  (click)="onRetryClicked()" style="background: #00409E;color: white" id="retrybtn"> {{retryButtonLabel}}</button>
</div>
